import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Row, Col, FormGroup, Label, Input, Button} from 'reactstrap';
import {TabelaCadastro} from "../../cadastros/components/TabelaCadastro";
import PainelDelegacaoStore from "../stores/PainelDelegacaoStore";
import Select from 'react-select';
import {createSelectOptions, formatarDataISO8601, motivoContratacaoFormatter, nullable} from "../../../utils/formatar";
import moment from "moment/moment";
import DatePicker from "react-datepicker";
import {Validacao} from "../../comum/components/Validacao";
import {ModalForm} from "../../comum/components/ModalForm";

const colunas = [
    {
        field: "usuarioResponsavel",
        label: "Usuário Responsável"
    },
    {
        field: "usuarioDelegado",
        label: "Usuário delegado"
    },
    {
        field: "dataInicio",
        label: "Data de início",
        dataFormat: formatarDataISO8601
    },
    {
        field: "dataTermino",
        label: "Data de término",
        dataFormat: formatarDataISO8601
    }
];

@inject("store")
@DataWrapper
@observer
export class PainelDelegacao extends Component {

    constructor(props) {
        super(props);
        this.modal = this.props.store.modalStore;
        this.controller = new PainelDelegacaoStore(this.modal);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.modalStore = this.props.store.modalStore;
        this.appStore = this.props.store.appStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Painel de delegações");
        this.controller.carregarLista();

        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            },{
                label: "Filtrar",
                icone: "search",
                acao: () => this.modalStore.toggleModal('filtrar')
            }
        ]);
    }

    modalForm = () => {
        return(
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Usuário Responsável <sup>*</sup></Label>
                        <Select simpleValue cacheAsyncResults={false} value={this.controller.delegacaoTela.usuarioResponsavel}
                                autoload={false}
                                disabled={this.modalStore.exibirModal.tipo == 'editar'}
                                onChange={(value) => this.controller.setNovaDelegacaoUsuarioResponsavel(value)}
                                searchPromptText="Informe nome para pesquisar" noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                asyncOptions={(input, callback) => this.controller.filtrarUsuarios(input, callback)} />
                        <Validacao id="usuarioResponsavelObrigatorio" valor={this.controller.delegacaoTela.usuarioResponsavel} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Delegar a <sup>*</sup></Label>
                        <Select simpleValue cacheAsyncResults={false} value={this.controller.delegacaoTela.usuarioDelegado}
                                autoload={false}
                                disabled={this.modalStore.exibirModal.tipo == 'editar'}
                                onChange={(value) => this.controller.setNovaDelegacaoUsuarioDelegado(value)}
                                searchPromptText="Informe nome para pesquisar" noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                asyncOptions={(input, callback) => this.controller.filtrarUsuarios(input, callback)} />
                        <Validacao id="usuarioDelegadoObrigatorio" valor={this.controller.delegacaoTela.usuarioDelegado} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Data inicial</Label>
                        <DatePicker
                            ref="dataInicio"
                            onClickOutside={()=>{this.refs.dataInicio.cancelFocusInput(); this.refs.dataInicio.setOpen(false);}}
                            locale={"pt_BR"}
                            className="form-control"
                            dateFormat="DD/MM/YYYY"
                            selectsStart
                            selected={this.controller.momentDataInicio}
                            minDate={moment()}
                            startDate={this.controller.momentDataInicio}
                            endDate={this.controller.momentDataTermino}
                            onChange={(value) => this.controller.setMomentDataInicio(value)}
                            onBlur={(e) => this.controller.setDataInicioCheck(e.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Data de término</Label>
                        <DatePicker
                            ref="dataFim"
                            onClickOutside={()=>{this.refs.dataFim.cancelFocusInput(); this.refs.dataFim.setOpen(false);}}
                            locale={"pt_BR"}
                            className="form-control"
                            dateFormat="DD/MM/YYYY"
                            selectsEnd
                            minDate={moment()}
                            selected={this.controller.momentDataTermino}
                            startDate={this.controller.momentDataInicio}
                            endDate={this.controller.momentDataTermino}
                            onChange={(value) => this.controller.setMomentDataTermino(value)}
                            onBlur={(e) => this.controller.setDataTerminoCheck(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
        )
    }

    obterTituloMobile = (objeto) => {
        return  objeto.usuarioResponsavel;
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "Usuário delegado: " +  nullable(objeto.usuarioDelegado)}<br/>
                { "Data de início: " + nullable(formatarDataISO8601(objeto.dataInicio))}<br/>
                { "Data de término: " + nullable(formatarDataISO8601(objeto.dataTermino))}<br/>
            </div>
        )
    };

    renderFilter(){
        return(
            <div className="filter-container">
                <div className="filter-box">
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Usuário</Label>
                                <Select simpleValue cacheAsyncResults={false} value={this.controller.usuarioFiltro}
                                        onChange={(value) => this.controller.setUsuarioFiltro(value)}
                                        autoload={false}
                                        searchPromptText="Informe nome para pesquisar" noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                        asyncOptions={(input, callback) => this.controller.filtrarUsuarios(input, callback)} />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Usuário delegado</Label>
                                <Select simpleValue cacheAsyncResults={false} value={this.controller.usuarioDelegadoFiltro}
                                        onChange={(value) => this.controller.setUsuarioDelegadoFiltro(value)}
                                        autoload={false}
                                        searchPromptText="Informe nome para pesquisar" noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                        asyncOptions={(input, callback) => this.controller.filtrarUsuarios(input, callback)} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <Button color="primary"  onClick={() => {this.controller.carregarLista(); this.modalStore.toggleModal()}} >Filtrar</Button>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

    renderDados(){
        return(
            <div>
                <TabelaCadastro
                    nomeCadastro={'Delegação'}
                    onChange={(value) => this.controller.setLista(value)}
                    listaItens={this.controller.delegacoes}
                    colunas={colunas}
                    temBusca={true}
                    criarNovos={true}
                    modalEditar={this.modalForm()}
                    modalCadastrar={this.modalForm()}
                    preencherModal={(row) => this.controller.preencherModal(row)}
                    editar={() => this.controller.editar()}
                    cadastrar={() =>this.controller.cadastrar()}
                    remover={() => this.controller.remover()}
                    tituloMobile={(row) => this.obterTituloMobile(row)}
                    conteudoMobile={(row) => this.obterConteudoMobile(row)}
                    loading={this.controller.loading}
                    mobileFilter={this.renderFilter()}
                />
            </div>
        );
    }

    render() {
        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        {this.appStore.width > 768 && this.renderFilter()}
                        {this.renderDados()}
                    </div>
                </div>
            </div>
        );
    }
}